import React from "react";
import { useTranslation } from "react-i18next";
import { useNotifications } from "../hooks/use-notifications";

export const NotificationCategorySection: React.FC = () => {
  const { t } = useTranslation();

  // Notifications hook - handles all state and actions
  const { categories, notificationSettings, handleToggle } = useNotifications();

  return (
    <div className="flex flex-col gap-6">
      {categories.map((category, index) => (
        <div key={category.id}>
          <div className="flex flex-col lg:flex-row lg:gap-16 gap-6">
            {/* Left: Category Info */}
            <div className="flex-1 max-w-[280px]">
              <h4 className="text-sm font-semibold text-text-secondary dark:text-text-secondary mb-1">
                {t(category.title)}
              </h4>
              <p className="text-sm text-text-tertiary dark:text-text-tertiary">
                {t(category.description)}
              </p>
            </div>

            {/* Right: Toggle Settings */}
            <div className="flex-1 max-w-[512px]">
              <div className="flex flex-col gap-4">
                {/* Push Toggle */}
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleToggle(category.id, "push")}
                    className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                      notificationSettings[category.id]?.push
                        ? "bg-green-500"
                        : "bg-gray-200 dark:bg-gray-700"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                        notificationSettings[category.id]?.push
                          ? "translate-x-4"
                          : "translate-x-0.5"
                      }`}
                    />
                  </button>
                  <span className="text-sm font-medium text-text-secondary dark:text-text-secondary">
                    {t("settings.notifications.push")}
                  </span>
                </div>

                {/* Email Toggle */}
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleToggle(category.id, "email")}
                    className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                      notificationSettings[category.id]?.email
                        ? "bg-green-500"
                        : "bg-gray-200 dark:bg-gray-700"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                        notificationSettings[category.id]?.email
                          ? "translate-x-4"
                          : "translate-x-0.5"
                      }`}
                    />
                  </button>
                  <span className="text-sm font-medium text-text-secondary dark:text-text-secondary">
                    {t("settings.notifications.email")}
                  </span>
                </div>

                {/* SMS Toggle */}
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleToggle(category.id, "sms")}
                    className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                      notificationSettings[category.id]?.sms
                        ? "bg-green-500"
                        : "bg-gray-200 dark:bg-gray-700"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                        notificationSettings[category.id]?.sms
                          ? "translate-x-4"
                          : "translate-x-0.5"
                      }`}
                    />
                  </button>
                  <span className="text-sm font-medium text-text-secondary dark:text-text-secondary">
                    {t("settings.notifications.sms")}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Divider (except for last item) */}
          {index < categories.length - 1 && (
            <div className="mt-6 h-px bg-border-secondary dark:bg-border-secondary"></div>
          )}
        </div>
      ))}
    </div>
  );
};
